import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App.js";
import { redirectTelegramLaunch } from "@/app/telegram-redirect.js";
import "./index.css";

// Telegram bosh manzilni ochib qo'ygan bo'lsa — Mini App'ga o'tkazamiz va
// saytni umuman chizmaymiz, aks holda odam bir lahza boshqa sahifani ko'radi.
if (!redirectTelegramLaunch()) {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("#root topilmadi");

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
